import React from 'react';
import { ReactComponent as CustomCatalogueGridTileIcon } from 'qs-assets/Media/ic_catalogue_grid_tile_icon.svg';
import './styles.scss';

export default ({ width, height, fill, classes = '' }) => {
  return (
    <CustomCatalogueGridTileIcon
      style={{ width, height, fill }}
      className={`settingsIconComponent ${classes}`}
    />
  );
};
